import React, {useEffect, useReducer, Suspense} from 'react';
import './App.css';
import {
  HashRouter,
  Routes,
  Route
} from "react-router-dom"

import ProductContext from './Components/Context/ProductContext';
import ProductReducer from './Components/Reducer/ProductReducer';
import ScrollTop from './Components/ScrollTop';
import Loading from './Components/Loading';
import data from './Data/Data';

const ProductPage = React.lazy(() => import('./Components/ProductPage'));
const CartPage = React.lazy(() => import('./Components/CartPage'));
const CatPage = React.lazy(() => import('./Components/CatPage'));
const SearchPage = React.lazy(() => import('./Components/SearchPage'));
const FinalCart = React.lazy(() => import('./Components/FinalCart'));
const IndexPage = React.lazy(() => import('./Components/IndexPage'));
const Footer = React.lazy(() => import('./Components/Footer'));
const Header = React.lazy(() => import('./Components/Header'));
const ContactUs = React.lazy(() => import('./Components/ContactUsPage'));
const AboutUs = React.lazy(() => import('./Components/AboutUsPage'));
const NumberPage = React.lazy(() => import('./Components/NumberPage'));
const ErrorPage = React.lazy(() => import('./Components/404Page'));
const NotFoundPage = React.lazy(() => import('./Components/NotFoundPage'));



function App() {

  useEffect(()=>{
    document.body.onscroll = function(){
      if(window.pageYOffset >= 400){
        document.getElementsByClassName('scroll-top')[0].classList.remove('opacity-0');
      }else{
        document.getElementsByClassName('scroll-top')[0].classList.add('opacity-0');
      }
    }
    document.getElementsByClassName('scroll-top')[0].addEventListener('click', function(){
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });
    
  }, []);
  
  let [state, action] = useReducer(ProductReducer, data);
  
  return (
    <HashRouter>
    
        <ProductContext.Provider value={{
          state,
          action
        }}>
        <Header />
        <Routes exact={true}>
        <Route path='/' element={<Suspense fallback={<Loading/>}><IndexPage /></Suspense>}/>
        <Route path='/product/:slug' element={<Suspense fallback={<Loading/>}><ProductPage /></Suspense>}/>
        <Route path='/cart' element={<Suspense fallback={<Loading/>}><CartPage /></Suspense>}/>
        <Route path='/cat/:ParentCat' element={<Suspense fallback={<Loading/>}><CatPage /></Suspense>}/>
        <Route path='/cat/:ParentCat/:ChildCat' element={<Suspense fallback={<Loading/>}><CatPage /></Suspense>}/>
        <Route path='/search/:word' element={<Suspense fallback={<Loading/>}><SearchPage /></Suspense>}/>
        <Route path='/search/' element={<Suspense fallback={<Loading/>}><SearchPage /></Suspense>}/>
        <Route path='/checkout' element={<Suspense fallback={<Loading/>}><FinalCart /></Suspense>}/>
        <Route path='/contact_us' element={<Suspense fallback={<Loading/>}><ContactUs /></Suspense>}/>
        <Route path='/about_us' element={<Suspense fallback={<Loading/>}><AboutUs /></Suspense>}/>
        <Route path='/order_code' element={<Suspense fallback={<Loading/>}><NumberPage /></Suspense>}/>
        <Route path='/404' element={<Suspense fallback={<Loading/>}><ErrorPage /></Suspense>}/>
        <Route path='/*' element={<Suspense fallback={<Loading/>}><NotFoundPage /></Suspense>}/>
        
        </Routes>
      <Footer />
        <ScrollTop />
        </ProductContext.Provider>
    
    </HashRouter>
  );
}

export default App;
